var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "passenger details-container details-container--thin",
      class: {
        "details-containerTs":
          _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
      },
    },
    [
      _c(
        "h3",
        {
          staticClass: "details-container__header",
          class: {
            "details-container__headerTs":
              _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
          },
        },
        [
          _vm._v(
            _vm._s(_vm.details.firstName) + " " + _vm._s(_vm.details.lastName)
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEditable,
              expression: "isEditable",
            },
          ],
          staticClass: "details-container__body",
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.passenger.summaryView,
                  expression: "passenger.summaryView",
                },
              ],
            },
            [
              _c(
                "button",
                {
                  staticClass: "details-container__edit-button",
                  class: {
                    "details-container__edit-buttonTs":
                      _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
                  },
                  attrs: {
                    "aria-label": "Edit your details",
                    title: "Click to edit your details",
                  },
                  on: { click: _vm.edit },
                },
                [_vm._v("Edit")]
              ),
              _vm._v(" "),
              _vm.passenger.summaryView
                ? _c("PassengerSummary", { attrs: { details: _vm.details } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.passenger.summaryView,
                  expression: "!passenger.summaryView",
                },
              ],
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("Input", {
                ref: "title",
                attrs: {
                  name: "title",
                  label: "Title",
                  placeholder: "Please select",
                  required: true,
                  options: _vm.titleOptions,
                  vuexPath: _vm.vuexPath,
                  value: _vm.title,
                },
                on: { change: _vm.selectTitleOptions },
                nativeOn: {
                  input: function ($event) {
                    return _vm.saveToSessionStorage(
                      "title",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("Input", {
                ref: "firstName",
                attrs: {
                  name: "firstName",
                  label: "First Name",
                  placeholder: "First Name",
                  required: true,
                  pattern: _vm.patterns.name,
                  title: _vm.titles.name,
                  trim: true,
                  vuexPath: _vm.vuexPath,
                },
                nativeOn: {
                  input: function ($event) {
                    return _vm.saveToSessionStorage(
                      "firstName",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("Input", {
                ref: "otherNames",
                attrs: {
                  name: "otherNames",
                  label: "Other Names",
                  placeholder: "Other Names",
                  pattern: _vm.patterns.name,
                  title: _vm.titles.name,
                  trim: true,
                  vuexPath: _vm.vuexPath,
                },
                nativeOn: {
                  input: function ($event) {
                    return _vm.saveToSessionStorage(
                      "otherNames",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c("Input", {
                ref: "lastName",
                attrs: {
                  name: "lastName",
                  label: "Surname",
                  placeholder: "Surname",
                  required: true,
                  pattern: _vm.patterns.name,
                  title: _vm.titles.name,
                  trim: true,
                  vuexPath: _vm.vuexPath,
                },
                nativeOn: {
                  input: function ($event) {
                    return _vm.saveToSessionStorage(
                      "lastName",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _vm.passenger.lead
                ? [
                    _c("Input", {
                      ref: "email",
                      attrs: {
                        name: "email",
                        type: "email",
                        label: "Email",
                        placeholder: "Email",
                        required: true,
                        vuexPath: _vm.vuexPath,
                        pattern: _vm.patterns.email,
                        title: _vm.titles.email,
                        trim: true,
                      },
                      nativeOn: {
                        input: function ($event) {
                          return _vm.saveToSessionStorage(
                            "email",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("Input", {
                      ref: "confirmEmail",
                      attrs: {
                        name: "confirmEmail",
                        type: "email",
                        label: "Confirm Email",
                        placeholder: "Confirm Email",
                        required: true,
                        customValidation: _vm.matchEmail,
                        vuexPath: _vm.vuexPath,
                        pattern: _vm.patterns.email,
                        title: _vm.titles.email,
                        trim: true,
                      },
                      nativeOn: {
                        input: function ($event) {
                          return _vm.saveToSessionStorage(
                            "confirmEmail",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("Input", {
                      ref: "mobilePhone",
                      attrs: {
                        name: "mobilePhone",
                        type: "tel",
                        label: "Mobile Phone Number",
                        placeholder: "Mobile Phone Number",
                        required: true,
                        pattern: _vm.patterns.telephone,
                        title: _vm.titles.telephone,
                        trim: true,
                        vuexPath: _vm.vuexPath,
                      },
                      nativeOn: {
                        input: function ($event) {
                          return _vm.saveToSessionStorage(
                            "mobilePhone",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("Input", {
                      ref: "homePhone",
                      attrs: {
                        name: "homePhone",
                        type: "tel",
                        label: "Home Phone Number",
                        placeholder: "Home Phone Number",
                        required: true,
                        pattern: _vm.patterns.telephone,
                        title: _vm.titles.telephone,
                        trim: true,
                        vuexPath: _vm.vuexPath,
                      },
                      nativeOn: {
                        input: function ($event) {
                          return _vm.saveToSessionStorage(
                            "homePhone",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.passenger.lead
                ? _c("Date", {
                    ref: "date",
                    attrs: {
                      validateAge: 18,
                      vuexPath: _vm.vuexPath,
                      under18ErrorMessage:
                        _vm.data.passengersError.under18ErrorMessage,
                    },
                    nativeOn: {
                      change: function ($event) {
                        return _vm.saveDateToSessionStorage.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  })
                : _c("Date", {
                    ref: "date",
                    attrs: {
                      vuexPath: _vm.vuexPath,
                      validateAge: 18,
                      under18ErrorMessage:
                        _vm.data.passengersError.under18ErrorMessage,
                    },
                    nativeOn: {
                      change: function ($event) {
                        return _vm.saveDateToSessionStorage.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  }),
              _vm._v(" "),
              _c("Input", {
                ref: "sex",
                attrs: {
                  name: "sex",
                  label: "Sex (indicated by passport)",
                  placeholder: "Please select",
                  required: true,
                  options: ["Male", "Female"],
                  vuexPath: _vm.vuexPath,
                },
                nativeOn: {
                  input: function ($event) {
                    return _vm.saveToSessionStorage("sex", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _vm.passenger.lead
                ? _c("AddressLookup", {
                    ref: "address",
                    attrs: {
                      title: "Billing Address",
                      vuexPath: _vm.vuexAddressPath,
                      brandName: _vm.data.brandNameFormatted,
                    },
                    on: { "address-updated": _vm.saveAddressToSessionStorage },
                    nativeOn: {
                      input: function ($event) {
                        return _vm.saveAddressToSessionStorage.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.visas.length
                ? _c("Visas", {
                    attrs: {
                      visas: _vm.visas,
                      description: _vm.data.passengerDetails.visaDescription,
                      vuexPath: _vm.vuexVisaPath,
                      currency: _vm.currency,
                    },
                    nativeOn: {
                      input: function ($event) {
                        return _vm.saveToSessionStorage(
                          "visa",
                          $event.target.value
                        )
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("Input", {
                ref: "mobilityLimitations",
                attrs: {
                  name: "mobilityLimitations",
                  label:
                    "Does this traveller have any medical conditions or mobility limitations?",
                  required: true,
                  options: [true, false],
                  optionsRadio: true,
                  startingValue: false,
                  vuexPath: _vm.vuexPath,
                },
                nativeOn: {
                  change: function ($event) {
                    return _vm.saveToSessionStorage(
                      "mobilityLimitations",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _vm.details.mobilityLimitations
                ? _c(
                    "div",
                    { staticClass: "mobility-text" },
                    [
                      _c("Input", {
                        ref: "mobilityDetails",
                        attrs: {
                          name: "mobilityDetails",
                          label: "Mobility Details",
                          placeholder: "Mobility details...",
                          required: _vm.details.mobilityLimitations,
                          vuexPath: _vm.vuexPath,
                        },
                        nativeOn: {
                          input: function ($event) {
                            return _vm.saveToSessionStorage(
                              "mobilityDetails",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.details.mobilityLimitations
                ? _c("div", { staticClass: "error-message" }, [
                    _c("div", { staticClass: "error-message__icon" }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "error-message__text",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.passengerDetails.medicalConditionWarning
                        ),
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("Input", {
                ref: "dietaryRequests",
                attrs: {
                  name: "dietaryRequests",
                  label:
                    "Does this traveller have any special dietary requests or allergies?",
                  description: _vm.data.passengerDetails.dietaryDescription,
                  required: true,
                  options: [true, false],
                  optionsRadio: true,
                  startingValue: false,
                  vuexPath: _vm.vuexPath,
                },
                nativeOn: {
                  change: function ($event) {
                    return _vm.saveToSessionStorage(
                      "dietaryRequests",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _vm.details.dietaryRequests
                ? _c(
                    "div",
                    { staticClass: "dietary-text" },
                    [
                      _c("Input", {
                        ref: "dietaryRequirements",
                        attrs: {
                          name: "dietaryRequirements",
                          label: "Dietary Requirements",
                          placeholder: "Dietary requirements...",
                          required: _vm.details.dietaryRequests,
                          vuexPath: _vm.vuexPath,
                        },
                        nativeOn: {
                          input: function ($event) {
                            return _vm.saveToSessionStorage(
                              "dietaryRequirements",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.passenger.lead
                ? [
                    _c("Input", {
                      ref: "termsAndConditions",
                      attrs: {
                        name: "termsAndConditions",
                        type: "checkbox",
                        label: _vm.termsAndConditionsLabel,
                        required: true,
                        vuexPath: _vm.vuexPath,
                      },
                      nativeOn: {
                        input: function ($event) {
                          return _vm.saveToSessionStorage(
                            "termsAndConditions",
                            $event.target.checked
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("Input", {
                      ref: "marketingMail",
                      attrs: {
                        name: "marketingMail",
                        type: "checkbox",
                        startingValue: true,
                        label: _vm.marketingMailLabel(),
                        vuexPath: _vm.vuexPath,
                      },
                      nativeOn: {
                        input: function ($event) {
                          return _vm.saveToSessionStorage(
                            "marketingMail",
                            $event.target.checked
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("Input", {
                      ref: "marketingEmail",
                      attrs: {
                        name: "marketingEmail",
                        type: "checkbox",
                        startingValue: true,
                        label: _vm.marketingEmailLabel(),
                        vuexPath: _vm.vuexPath,
                      },
                      nativeOn: {
                        input: function ($event) {
                          return _vm.saveToSessionStorage(
                            "marketingEmail",
                            $event.target.checked
                          )
                        },
                      },
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "details-container__footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn details-container__submit",
                    attrs: {
                      "aria-label": "Save and continue",
                      title: "Click to save and continue",
                    },
                    on: { click: _vm.save },
                  },
                  [_vm._v("Save and continue")]
                ),
              ]),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "details-container__body-intro" }, [
      _c("p", [_vm._v("Enter details as they appear on the passport")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }